import React, {useState, useEffect, useRef} from 'react';
import './forgiveDebt.scss';
import Arrow from '../../../../assets/icons/caret-down.svg';

const  ForgiveDebtModal = ({forgiveValue, submitForgive, isForgive = false, closeForgive}) => {
    const [isModal, setIsModal] = useState(false);

    const modalRef = useRef();
    const forgive = JSON.parse(isForgive);
    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setIsModal(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const onClickHandler = () => {
        submitForgive();
        setIsModal(false);
    }

    const handleModalClick = (event) => {
        event.stopPropagation();
    };

    const cancelOperation = () => {
        if (isForgive) {
            closeForgive();
        }
        setIsModal(false);
    }

    return (
        <div>
            <div className='forgiveDebt-penaltyBlock'>
                <span
                   className='forgiveDebt-value'
                   id="target-element"
                   onClick={() => {
                   setIsModal(!isModal);
                   }}
                >
                {forgive ? '0.00 руб.' : forgiveValue}
                </span>
                <Arrow className={`${isModal ? 'forgiveDebt-arrowIcon' : ''}`} />
            </div>
            <div
                ref={modalRef}
                className={`forgiveDebt ${isModal ? 'open' : 'closed'}`}
                onClick={handleModalClick}
            >
                <div className="forgiveDebt-header">
                    <span>Простить весь долг</span>
                </div>
                <div className="forgiveDebt-body">
                    <span className="forgiveDebt-forgiveValue">
                        {forgive ? '0.00 руб.' : forgiveValue}
                    </span>
                </div>
                <div className='forgiveDebt-blockButton'>
                    <button
                        className={forgive ? 'button-light forgiveDebt-disabledButton' : 'button forgiveDebt-submit'}
                        type='button'
                        onClick={onClickHandler}
                        disabled={forgive}
                    >Да</button>
                    <button
                        className='forgiveDebt-disabledButton'
                        type='button'
                        onClick={cancelOperation}
                    >{forgive ? 'Отменить' : 'Нет'}</button>
                </div>
            </div>
        </div>
    );
}

export default ForgiveDebtModal;